import { assetUrl } from '../config/asset-config';

(function () {
    'use strict';

    angular.module('thankview.global')
        .factory('stripeService', ['$rootScope', 'ajax', '$q', '$window', '$document', '$timeout', ($rootScope, ajax, $q, $window, $document, $timeout) => {
            const stripeService = {};
            let stripeLoaded = false;
            let stripe;

            /**
             * Initialize stripe
             * @param {Function} processTokenCallback - callback after retrieving token
             * @param {Function} openedCallback - callback after opening the stripe payment window
             * @param {Function} closedCallback - callback after closing the stripe payment window
             */
            stripeService.init = (processTokenCallback, openedCallback, closedCallback) => {
                stripeService.load();

                if (!$window.StripeCheckout) {
                    $timeout(() => {
                        stripeService.init(processTokenCallback, openedCallback, closedCallback);
                    }, 100);
                    return;
                }

                stripe = StripeCheckout.configure({
                    key: config.stripe,
                    image: assetUrl('assets/img/icon_logo_navy.png'),
                    allowRememberMe: false,
                    zipCode: false,
                    token: processTokenCallback,
                    opened: openedCallback,
                    closed: closedCallback,
                });
            };

            /**
             * Load stripe's library
             */
            stripeService.load = function () {
                if (stripeLoaded) {
                    return;
                }

                stripeLoaded = true;

                const e = $document[0].createElement('script');
                e.src = 'https://checkout.stripe.com/checkout.js';
                $document[0].head.appendChild(e);
            };

            /**
             * Open Stripe Checkout to only ask for credit card info
             * without making a charge
             */
            stripeService.inputCard = (desc) => {
                stripe.open({
                    name: 'ThankView',
                    email: config.user.email,
                    zipCode: false,
                    panelLabel: desc,
                });
            };

            /**
             * Open Stripe Checkout to ask for credit card
             * and charge an amount
             */
            stripeService.chargeCard = (amount, desc) => {
                stripe.open({
                    name: 'ThankView',
                    description: desc,
                    email: config.user.email,
                    zipCode: false,
                    currency: 'usd',
                    amount: amount,
                });
            };

            return stripeService;
        }]);
}());
